import { action, observable } from 'mobx';
import moment from 'moment';
import Validator from 'validatorjs';

import { getClaimInfo, saveClaimant, getAssessmentHistory } from './service';
import { formatDate } from '../../../utils/functions';

const INIT_CLAIM = {
  Address: null,
  DOB: null,
  Email: null,
  FirstName: null,
  FullName: null,
  HomePhone: null,
  Id: 0,
  LastName: null,
  NonDOB: true,
  Telephone: null,
  Title: 'Mr.',
};

const VALIDATE_RULES = {
  FirstName: 'required',
  LastName: 'required',
  Telephone: 'max:10',
  HomePhone: 'max:10',
  Email: 'email',
};

const ERROR_MESSAGES = {
  required: 'This field is required',
  email: 'Invalid email address',
  max: {
    string: 'Must be less than or equal to :max digits',
  },
};

class AddEdditClaimStore {
  @observable loading = true;
  @observable claimantInfo = INIT_CLAIM;

  @observable claimantInfo_ = INIT_CLAIM;
  @observable isChanged = {};

  //Save
  @observable loadingSave = false;

  //History
  @observable loadingHistory = true;
  @observable dataHistory = null;

  //Check duplicate
  @observable loadingCheckDuplicate = false;

  //Error
  @observable errors = {};

  //Modal
  @observable open = false;
  @observable modalParams = {};

  toggleModal = (isOpen, params = {}) => {
    return action(() => {
      this.open = isOpen;
      this.modalParams = params;
    });
  };
  //

  renderDOB = date => {
    const date_ = date ? date : `N/A`;
    if (date_ === `N/A`) {
      return date_;
    } else {
      return moment(formatDate(date_), 'DD MMM YYYY');
    }
  };

  @action setFieldsValue = data => {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
  };

  @action fetchAll = claimantId => {
    this.loading = true;
    Promise.all([
      getClaimInfo(claimantId),
      getAssessmentHistory(claimantId),
    ]).then(
      action(([info, assessmentHistory]) => {
        this.claimantInfo = { ...info, DOB: this.renderDOB(info.DOB) };
        this.dataHistory = assessmentHistory;
        this.loadingHistory = false;
        this.claimantInfo_ = { ...info, DOB: this.renderDOB(info.DOB) };
        this.loading = false;
      }),
    );
  };

  @action handleValidate = (field, value) => {
    const validation = new Validator(
      { [field]: value },
      { [field]: VALIDATE_RULES[field] },
      ERROR_MESSAGES,
    );

    if (validation.passes()) {
      delete this.errors[field];
    } else {
      this.errors[field] = validation.errors.first(field);
    }
  };

  @action initClamantData = () => {
    this.loading = false;
    this.claimantInfo = INIT_CLAIM;
    this.claimantInfo_ = INIT_CLAIM;
  };

  handleFieldChange = fieldName =>
    action(event => {
      if (fieldName === 'HomePhone' || fieldName === 'Telephone') {
        const value = event
          ? event.target
            ? event.target.value
            : event
          : null;

        this.claimantInfo[fieldName] = value
          .replace(/\D/g, '')
          .replace(/[^\d]/g, '');

        if (this.claimantInfo[fieldName] !== this.claimantInfo_[fieldName]) {
          this.isChanged[fieldName] = true;
        } else {
          delete this.isChanged[fieldName];
        }
      } else if (fieldName === 'DOB') {
        const value = event
          ? event.target
            ? event.target.value
            : event
          : null;
        const today = moment();
        const isBefore = moment(value).isBefore(today);
        this.claimantInfo[fieldName] = value;
        if (this.claimantInfo[fieldName] !== this.claimantInfo_[fieldName]) {
          this.isChanged[fieldName] = true;
        } else {
          delete this.isChanged[fieldName];
        }
        if (!isBefore && !!value) {
          this.errors = {
            ...this.errors,
            DOB: 'Date of Birth cannot be a future date',
          };
        } else {
          delete this.errors[fieldName];
        }
        return;
      } else {
        const value = event
          ? event.target
            ? event.target.value
            : event
          : null;

        this.claimantInfo[fieldName] = value;

        if (this.claimantInfo[fieldName] !== this.claimantInfo_[fieldName]) {
          this.isChanged[fieldName] = true;
        } else {
          delete this.isChanged[fieldName];
        }
      }
      if (VALIDATE_RULES[fieldName]) {
        this.handleValidate(fieldName, this.claimantInfo[fieldName]);
      }
    });

  @action resetStore = () => {
    this.loading = true;
    this.dataHistory = null;
    this.claimantInfo = INIT_CLAIM;
    this.claimantInfo_ = INIT_CLAIM;
    this.loadingHistory = true;
  };

  convertBirthDate = dateString => {
    if (dateString) {
      if (typeof dateString === 'string') {
        if (dateString.search('/Date') !== -1) {
          const dateFormat = formatDate(dateString);
          return moment(dateFormat, 'DD MMM,YYYY');
        }
      } else {
        return moment(dateString, 'DD/MM/YYYY');
      }
    }
    return null;
  };

  @action handleSaveClaimant = () => {
    this.loadingSave = true;
    const birthDate = this.convertBirthDate(this.claimantInfo.DOB);
    const body = {
      ...this.claimantInfo,
      DOB: birthDate,
    };
    return saveClaimant(body);
  };
}

export default new AddEdditClaimStore();
